export default "__VITE_ASSET__c43b947d__"